module.exports = __webpack_public_path__ + "img/produkt-repa.79b3933b.jpg";